export default __webpack_public_path__ + "static/nativo-be352fde75817218ff25c0b72a787698.svg";